<template>
  <div>
    <div class="settings_line" v-if="participants.length">
      <p>Participant(s): ({{ participants.length }})</p>
    </div>

    <div
        class="modal_user"
        v-for="participant in participants"
        v-bind:key="participant.userId"
    >
      <participant-avatar :participant="participant"/>

      <div class="name">
        {{ participant.user_name }}
        {{ participant.local ? "(you)" : "" }}
        {{ participant.owner ? "(admin)" : "" }}
      </div>

      <participantDropDowm
          :id="participant.user_id"
          :participant="participant"
          v-if="localParticipant.owner && !participant.isLocal"
      ></participantDropDowm>
    </div>

    <div class="settings_line" v-if="waitingParticipants.length">
      <br/>
      <p>Participant(s): {{ waitingParticipants.length }}</p>
    </div>

    <div
        class="modal_user"
        v-for="participant in waitingParticipants"
        v-bind:key="participant.id"
    >
      <participant-avatar :participant="participant"/>

      <div class="name">
        {{ participant.name }}
      </div>

      <div class="buttons_wrap">
        <button
            class="hover_op"
            @click="
            $store.dispatch('updateWaitingParticipant', {
              id: participant.id,
              grantRequestedAccess: true,
            })
          "
        >
          <img src="@/assets/img/accept_icon.svg" alt=""/>
        </button>

        <button
            class="hover_op"
            @click="
            $store.dispatch('updateWaitingParticipant', {
              id: participant.id,
              grantRequestedAccess: false,
            })
          "
        >
          <img src="@/assets/img/mob_close_menu_icon.svg" alt=""/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import participantDropDowm from "@/components/participantDropDowm.vue";
import ParticipantAvatar from "./meeting/ParticipantAvatar";

export default {
  name: "Participants",

  components: {
    ParticipantAvatar,
    participantDropDowm,
  },

  computed: {
    waitingParticipants() {
      return this.$store.state.meeting.waitingParticipants;
    },

    localParticipant() {
      return this.$store.getters.localParticipant;
    },

    participants() {
      return this.$store.state.meeting.participants;
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons_wrap {
  line-height: 0;

  button {
    height: 34px;
    width: 34px;

    img {
      object-fit: contain;
    }

    & + button {
      margin-left: 16px;
    }
  }
}
</style>
